export default {
    fundFocus(state) {
        return state.fundFocus;
    },
    marketCommentary(state) {
        return state.marketCommentary;
    },
    getResearchReminders(state) {
        return state.researchReminders;
    },
};
